import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down-right', 'ArrowLongDownRight', [["path",{"d":"M19 13v6m0 0h-6m6 0L5 5","key":"svg-0"}]]);